import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Remove from '@/images/Remove.svg';
import { LibraryItem } from '@d-id/types';
import { useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, RedListItemText } from './components';

interface Props {
    video: LibraryItem;
    onDelete: (video: LibraryItem) => void;
    closeMenu: () => void;
}

export const DeleteMenuItem = ({ video, onDelete, closeMenu }: Props) => {
    const theme = useTheme();

    return (
        <MenuItem
            disabled={video.is_default}
            onClick={() => {
                onDelete(video);
                closeMenu();
            }}>
            <ListItemIcon>
                <MaskedIcon src={Remove} size="24px" color={theme.colors.error.main} />
            </ListItemIcon>
            <RedListItemText>Delete</RedListItemText>
        </MenuItem>
    );
};
